// Pure helpers for the "Student Image" crop step (photo_crop_controller.js).
// Split out from the controller because it doesn't touch the DOM/canvas, so
// it can be unit tested directly (the controller's Cropper.js/canvas glue
// can't be meaningfully unit tested without a real browser).

// The cropped output is always re-encoded as JPEG, so the filename we hand
// back to the server should say so too — swap (or add) a .jpg extension
// rather than keeping the original's (e.g. a webcam's "capture.png" or a
// phone's "IMG_0001.HEIC").
export function jpegFileName(originalName) {
  const base = (originalName || '').trim().replace(/\.[^./\\]+$/, '');

  return `${base || 'student-photo'}.jpg`;
}
